export const HOME = '/';
export const CONTACT_US = '/contact_us';
export const STANDARD_PRIVACY_POLICY = 'privacy_policy';
export const STANDARD_TERMS = 'terms';
export const META_DATA_DELETION = 'meta-data-deletion';
export const BADDYBUDDY_PRIVACY_POLICY = 'baddybuddy/privacy_policy';
export const BADDYBUDDY_TERMS = 'baddybuddy/terms';
export const OUTFITS_PRIVACY_POLICY = 'outfits/privacy_policy';
export const OUTFITS_TERMS = 'outfits/terms';